import range from 'lodash/range';
import styled, { keyframes } from 'styled-components';

import AndroidSpinner from '../icons/android-loading.svg';
import IOSSpinner from '../icons/iOS-loading.svg';

import { FULL_VH } from './Common';
import theme, { isiOS } from '../themes';

const iOSPulse = keyframes`
  50% { fill: #868686; }
  to { fill: rgba(134, 134, 134, .4) }
`;

const androidDashOffset = 187;
const androidLoadingDuration = '1.4s';

const androidDash = keyframes`
  0% {
    stroke-dashoffset: ${androidDashOffset};
  }
  50% {
    stroke-dashoffset: ${(androidDashOffset / 4).toFixed(2)};
    transform:rotate(135deg);
  }
  100% {
    stroke-dashoffset: ${androidDashOffset};
    transform:rotate(450deg);
  }
`;

const androidRotation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(270deg); }
`;

const svgiOS = `
  height: 27px;
  width: 27px;
  fill: #868686;

  path {
    ${
      range(12).map((value) =>
        `
          &:nth-of-type(${value + 1}) {
            animation: ${iOSPulse} 1s ${-0.083 * value}s infinite linear;
          }
        `
      ).join('')
    }
  }
`;

const svgAndroid = `
  height: 40px;
  width: 40px;
  animation: ${androidRotation} ${androidLoadingDuration} linear infinite;

  circle {
    stroke: #00B0B9;
    stroke-dasharray: ${androidDashOffset};
    stroke-dashoffset: 0;
    transform-origin: center;
    animation: ${androidDash} ${androidLoadingDuration} ease-in-out infinite;
  }
`;

export default styled.div.attrs({
  dangerouslySetInnerHTML: {
    __html: isiOS() ? IOSSpinner : AndroidSpinner
  }
})`
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  height: ${FULL_VH - theme.NavbarHeight}px;
  width: 100vw;
  svg {
    ${isiOS() ? svgiOS : svgAndroid}
  }
`;



// WEBPACK FOOTER //
// ./src/components/loading.js